import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, inject, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import * as Sentry from "@sentry/angular";

import { routes } from './app.routes';
import { provideStore, Store } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideHttpClient } from '@angular/common/http';

import {NG_EVENT_PLUGINS} from '@taiga-ui/event-plugins';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslationLoader } from './custom-translations-loader';
import { getRouterSelectors, provideRouterStore, routerReducer } from '@ngrx/router-store';

import { TUI_BELARUSIAN_LANGUAGE, TUI_CHINESE_LANGUAGE, TUI_DUTCH_LANGUAGE, TUI_ENGLISH_LANGUAGE, TUI_FRENCH_LANGUAGE, TUI_GERMAN_LANGUAGE, TUI_GREEK_LANGUAGE, TUI_HEBREW_LANGUAGE, TUI_ITALIAN_LANGUAGE, TUI_JAPAN_LANGUAGE, TUI_KAZAKH_LANGUAGE, TUI_KOREAN_LANGUAGE, TUI_LANGUAGE, TUI_LITHUANIAN_LANGUAGE, TUI_MALAY_LANGUAGE, TUI_POLISH_LANGUAGE, TUI_PORTUGUESE_LANGUAGE, TUI_RUSSIAN_LANGUAGE, TUI_SPANISH_LANGUAGE, TUI_TURKISH_LANGUAGE, TUI_UKRAINIAN_LANGUAGE, TUI_VIETNAMESE_LANGUAGE,  } from '@taiga-ui/i18n'
import { TUI_ARABIC_LANGUAGE, TUI_SWEDISH_LANGUAGE, TUI_DANISH_LANGUAGE, TUI_FINNISH_LANGUAGE, TUI_NORWEGIAN_LANGUAGE, TUI_CZECH_LANGUAGE, TUI_HUNGARIAN_LANGUAGE, TUI_ROMANIAN_LANGUAGE, TUI_BULGARIAN_LANGUAGE, TUI_LATVIAN_LANGUAGE, TUI_INDONESIAN_LANGUAGE, TUI_THAI_LANGUAGE, TUI_ESTONIAN_LANGUAGE, TUI_CROATIAN_LANGUAGE, TUI_SLOVENIAN_LANGUAGE, TUI_SERBIAN_LANGUAGE, TUI_FILIPINO_LANGUAGE, TUI_ICELANDIC_LANGUAGE } from './taiga-i18n-extra'
import { map, tap } from 'rxjs';

const {selectQueryParam} = getRouterSelectors();

// Locales
import { registerLocaleData } from '@angular/common';
import moment from 'moment';
import 'moment/min/locales.min'

// Import locales
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import localeZh from '@angular/common/locales/zh';
import localeAr from '@angular/common/locales/ar';
import localeKo from '@angular/common/locales/ko';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localeSv from '@angular/common/locales/sv';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import localeVi from '@angular/common/locales/vi';
import localeId from '@angular/common/locales/id';
import localeTh from '@angular/common/locales/th';
import localeHi from '@angular/common/locales/hi';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeFi from '@angular/common/locales/fi';
import localeNo from '@angular/common/locales/no';
import localeEl from '@angular/common/locales/el';
import localeHe from '@angular/common/locales/he';
import localeRo from '@angular/common/locales/ro';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeHu from '@angular/common/locales/hu';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeEt from '@angular/common/locales/et';
import localeBg from '@angular/common/locales/bg';
import localeHr from '@angular/common/locales/hr';
import localeSr from '@angular/common/locales/sr';
import localeFa from '@angular/common/locales/fa';
import localeSw from '@angular/common/locales/sw';
import localeAf from '@angular/common/locales/af';
import localeAz from '@angular/common/locales/az';
import localeBe from '@angular/common/locales/be';
import localeBn from '@angular/common/locales/bn';
import localeEu from '@angular/common/locales/eu';
import localeGl from '@angular/common/locales/gl';
import localeKa from '@angular/common/locales/ka';
import localeKm from '@angular/common/locales/km';
import localeMk from '@angular/common/locales/mk';
import localeMs from '@angular/common/locales/ms';
import localeSq from '@angular/common/locales/sq';
import localeTa from '@angular/common/locales/ta';
import localeTe from '@angular/common/locales/te';
// Add more as needed

// Register all locales
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeJa, 'ja');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeZh, 'zh');
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeKo, 'ko');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localePl, 'pl');
registerLocaleData(localeSv, 'sv');
registerLocaleData(localeTr, 'tr');
registerLocaleData(localeUk, 'uk');
registerLocaleData(localeVi, 'vi');
registerLocaleData(localeId, 'id');
registerLocaleData(localeTh, 'th');
registerLocaleData(localeHi, 'hi');
registerLocaleData(localeCs, 'cs');
registerLocaleData(localeDa, 'da');
registerLocaleData(localeFi, 'fi');
registerLocaleData(localeNo, 'no');
registerLocaleData(localeEl, 'el');
registerLocaleData(localeHe, 'he');
registerLocaleData(localeRo, 'ro');
registerLocaleData(localeSk, 'sk');
registerLocaleData(localeSl, 'sl');
registerLocaleData(localeHu, 'hu');
registerLocaleData(localeLt, 'lt');
registerLocaleData(localeLv, 'lv');
registerLocaleData(localeEt, 'et');
registerLocaleData(localeBg, 'bg');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeSr, 'sr');
registerLocaleData(localeFa, 'fa');
registerLocaleData(localeSw, 'sw');
registerLocaleData(localeAf, 'af');
registerLocaleData(localeAz, 'az');
registerLocaleData(localeBe, 'be');
registerLocaleData(localeBn, 'bn');
registerLocaleData(localeEu, 'eu');
registerLocaleData(localeGl, 'gl');
registerLocaleData(localeKa, 'ka');
registerLocaleData(localeKm, 'km');
registerLocaleData(localeMk, 'mk');
registerLocaleData(localeMs, 'ms');
registerLocaleData(localeSq, 'sq');
registerLocaleData(localeTa, 'ta');
registerLocaleData(localeTe, 'te');

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideStore({
      router: routerReducer,
    }),
    provideRouterStore(),
    provideEffects(),
    ...[(isDevMode())? provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true // If set to true, the connection is established within the Angular zone
    }) : []],
    provideHttpClient(),
    NG_EVENT_PLUGINS,
    importProvidersFrom(
      [
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useClass: CustomTranslationLoader,
            deps: [Store]
          },
        })
      ]
    ),
    {
      provide: LOCALE_ID, useFactory: ()=>{
        let lang = new URL(window.location.toString()).searchParams.get('lang');
        lang = (lang == 'ar')? 'ar-MA' : lang //i do this to show latin numbers instead
        moment.locale(lang as string)
        return lang;
      }
    },
    {
      provide: TUI_LANGUAGE,
      useFactory: ()=>{
        const _s = inject(Store)
        return _s.select(selectQueryParam('lang')).pipe(map(cl => {
          switch (cl) {
            case 'ar':
              return TUI_ARABIC_LANGUAGE;
            case 'be':
              return TUI_BELARUSIAN_LANGUAGE;
            case 'zh':
              return TUI_CHINESE_LANGUAGE;
            case 'nl':
              return TUI_DUTCH_LANGUAGE;
            case 'fr':
              return TUI_FRENCH_LANGUAGE;
            case 'de':
              return TUI_GERMAN_LANGUAGE;
            case 'el':
              return TUI_GREEK_LANGUAGE;
            case 'he':
              return TUI_HEBREW_LANGUAGE;
            case 'it':
              return TUI_ITALIAN_LANGUAGE;
            case 'ja':
              return TUI_JAPAN_LANGUAGE;
            case 'kk':
              return TUI_KAZAKH_LANGUAGE;
            case 'ko':
              return TUI_KOREAN_LANGUAGE;
            case 'lt':
              return TUI_LITHUANIAN_LANGUAGE;
            case 'ms':
              return TUI_MALAY_LANGUAGE;
            case 'pl':
              return TUI_POLISH_LANGUAGE;
            case 'pt':
              return TUI_PORTUGUESE_LANGUAGE;
            case 'ru':
              return TUI_RUSSIAN_LANGUAGE;
            case 'es':
              return TUI_SPANISH_LANGUAGE;
            case 'tr':
              return TUI_TURKISH_LANGUAGE;
            case 'uk':
              return TUI_UKRAINIAN_LANGUAGE;
            case 'vi':
              return TUI_VIETNAMESE_LANGUAGE;
            case 'sv':
              return TUI_SWEDISH_LANGUAGE;
            case 'da':
              return TUI_DANISH_LANGUAGE;
            case 'fi':
              return TUI_FINNISH_LANGUAGE;
            case 'no':
              return TUI_NORWEGIAN_LANGUAGE;
            case 'cs':
              return TUI_CZECH_LANGUAGE;
            case 'hu':
              return TUI_HUNGARIAN_LANGUAGE;
            case 'ro':
              return TUI_ROMANIAN_LANGUAGE;
            case 'bg':
              return TUI_BULGARIAN_LANGUAGE;
            case 'lv':
              return TUI_LATVIAN_LANGUAGE;
            case 'id':
              return TUI_INDONESIAN_LANGUAGE;
            case 'th':
              return TUI_THAI_LANGUAGE;
            case 'et':
              return TUI_ESTONIAN_LANGUAGE;
            case 'hr':
              return TUI_CROATIAN_LANGUAGE;
            case 'sk':
              return TUI_SLOVENIAN_LANGUAGE;
            case 'sr':
              return TUI_SERBIAN_LANGUAGE;
            case 'tl':
              return TUI_FILIPINO_LANGUAGE;
            case 'is':
              return TUI_ICELANDIC_LANGUAGE;
            default:
              return TUI_ENGLISH_LANGUAGE;
          }
        }))
      }
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};

